import { Theme, useMediaQuery } from '@mui/material';

type Point = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const useBreakpoints = (point: Point) => {
  return useMediaQuery(({ breakpoints }: Theme) => breakpoints.down(point));
};

export default useBreakpoints;
